var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 1.60417C0.875 1.20225 1.20225 0.875 1.60417 0.875H12.3958C12.7977 0.875 13.125 1.20225 13.125 1.60417V12.3958C13.125 12.7977 12.7977 13.125 12.3958 13.125H1.60417C1.20225 13.125 0.875 12.7977 0.875 12.3958V1.60417ZM12.3958 14C13.2807 14 14 13.2807 14 12.3958V1.60417C14 0.71925 13.2807 0 12.3958 0H1.60417C0.71925 0 0 0.71925 0 1.60417V12.3958C0 13.2807 0.71925 14 1.60417 14H12.3958ZM5.04996 8.75L4.7337 10.4108L5.59295 10.5744L5.94037 8.75H7.38342L7.06705 10.4114L7.9263 10.575L8.27383 8.75H10.5V7.875H8.44045L8.7737 6.125H10.5V5.25H8.94033L9.25581 3.59331L8.39655 3.42969L8.04992 5.25H6.60687L6.92246 3.5927L6.06321 3.42908L5.71646 5.25H3.5V6.125H5.54983L5.21658 7.875H3.5V8.75H5.04996ZM6.44024 6.125H7.88329L7.55004 7.875H6.10699L6.44024 6.125Z",
    fill: "#848996"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.131d10e1516c0c0170567004bc733819.svg";
export { ForwardRef as ReactComponent };